import { useEffect, useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { useUserContext } from '../../../contexts/UserContext';

import api from '../../../services/api';
import FormStyle from '../../My/Account/FormStyle';
import ErrorMessageCard from './ErrorMessageCard';

function ChangedEmailWithSuccess() {
  // variables
  const { token } = useParams();
  const Navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { updateUserContext } = useUserContext();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const handleConfirm = async () => {
    api.post(`v1/users/email-change/${token}`)
      .then((response) => {
        const { isTokenValid } = response.data.data;

        if (isTokenValid) {
          updateUserContext(response.data.data);
        } else {
          setErrorMessage('トークンの有効期限が切れています。');
        }
      }).catch((error) => {
        if (error.response?.status === 404) {
          setErrorMessage('トークンが無効です。');
        } else {
          setErrorMessage('メールアドレスの変更に失敗しました。');
        }
      }).finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (token) {
      handleConfirm();
    }
  }, []);

  if (isLoading || errorMessage) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="90vh"
      >
        {isLoading
          ? <CircularProgress />
          : errorMessage
            && (
            <ErrorMessageCard
              message={errorMessage}
              backButtonText="プロフィールへ戻る"
              backButtonAction={() => Navigate('/my-account')}
            />
            )}
      </Box>
    );
  }

  return (
    <div className="main">
      <main
        style={{
          overflowY: 'auto',
          height: 'calc(100vh - 65px)',
        }}
      >
        <Box className="container-fluid my-2">
          <Box
            sx={FormStyle.previewHeader}
          >
            <h1 className="text-bold my-3">
              メールアドレス変更
            </h1>
          </Box>
          <Box className="text-bold text-danger" sx={FormStyle.errorMessage}>
            {errorMessage}
          </Box>
          <Box className="card">
            <Box className="card-body">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <h3>メールアドレスの変更が完了いたしました。</h3>
                <FontAwesomeIcon
                  size="8x"
                  color="rgb(28, 187, 140)"
                  icon={faCircleCheck}
                  className="my-5"
                />
                <Button
                  onClick={() => Navigate('/my-account')}
                  variant="outlined"
                  className="btn-outline-secondary"
                >
                  戻る
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </main>
    </div>
  );
}

export default ChangedEmailWithSuccess;
